const TAB_KEY = 'idCards'
export default {
  name: 'idCards',

  computed: {
    idCardsCreateConfig () {
      return {
        title: this.$t('people/person.cards'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            type: 'dynamic-columns',
            showInitialRows: 1,
            showButtons: false,
            bordered: false,
            title: this.$t('people/person.cards'),
            component: this.dynamicColumnsContentComponent,
            key: 'cards',
            display_props: ['id_card_id'],
            useInitialAutocompletes: true,
            headers: [this.$t('people/person.id_card_type')],
            fields: [
              {
                key: 'id_card_id',
                type: 'autocomplete',
                autocomplete_options: {
                  module: 'people',
                  route: 'id-cards/autocomplete'
                },
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  }
}
